import _ from 'lodash'
import type {ComponentWithResolvedDataItems, SchemaService} from '@wix/document-services-types'
import type {CorePlugin, CorePluginFunction, SingleComponentPlugin, SingleComponentPluginFunction} from './types'

const createPluginFuncFromSingleComponentPluginFunc = (
    plugin: SingleComponentPlugin,
    getPluginFuncToRun: (plugin: SingleComponentPlugin) => SingleComponentPluginFunction | undefined
): CorePluginFunction | undefined => {
    const pluginFunc = getPluginFuncToRun(plugin)
    if (!_.isFunction(pluginFunc)) {
        return
    }

    return (componentExport: ComponentWithResolvedDataItems, schemaService: SchemaService) => {
        for (const component of _.values(componentExport.components)) {
            if (plugin.components?.has(component.type) !== false) {
                pluginFunc(component, schemaService)
            }
        }
    }
}

export const createPluginFromSingleComponentPlugin = (plugin: SingleComponentPlugin): CorePlugin => ({
    ...plugin,
    pack: createPluginFuncFromSingleComponentPluginFunc(plugin, p => p.pack),
    unpack: createPluginFuncFromSingleComponentPluginFunc(plugin, p => p.unpack)
})
